<template>
  <div>
    <Main
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      :height="height"
      @openDetailDialog="openDetailDialog"
      @batchDel="submitDel"
      ref="tableMain"
    >
      <Header
        ref="tableHeader"
        slot="header"
        :disabled="disabled"
        @openDetailDialog="openDetailDialog"
        @batchDel="$refs.tableMain.removeCheckboxRow()"
      />
    </Main>

    <el-dialog
      v-if="goodsSpecDetailDialogParams.visible"
      show-close
      :visible.sync="goodsSpecDetailDialogParams.visible"
      width="1000px"
      :title="goodsSpecDetailDialogParams.title"
      :close-on-click-modal="false"
      append-to-body
      :before-close="() => (goodsSpecDetailDialogParams.visible = false)"
    >
      <DetailForm
        ref="detailForm"
        :disabled="goodsSpecDetailDialogParams.disabled"
        :changeOrderGoodsCode="changeOrderGoodsCode"
        :form="goodsSpecDetailDialogParams.form"
        :type="goodsSpecDetailDialogParams.type"
      />
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button
          type="primary"
          size="small"
          v-if="!goodsSpecDetailDialogParams.disabled"
          @click="save()"
        >
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import Main from './main.vue'
import Header from './header.vue'
import DetailForm from '../components/detail'
export default {
  components: { Main, Header, DetailForm },
  props: {
    changeOrderGoodsCode: { type: String, default: '' },
    orderGoodsCode: { type: String, default: '' },
    changeOrderCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    height: { type: Number, default: 400 },
  },
  data() {
    return {
      loading: false,
      tableData: [],
      goodsSpecDetailDialogParams: {
        visible: false,
        title: '',
        type: '',
        disabled: false,
        form: {},
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.changeOrderGoodsCode) return
      this.loading = true
      this.$api
        .changeGoodsSpecListApi({
          changeOrderCode: this.changeOrderCode,
          orderGoodsCode: this.orderGoodsCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
          this.tableData = this.tableData.map((i) => {
            i.orderGoodsSpecCode = '',
            i.changeOrderGoodsSpecCode = ''
            return i
          })
        })
    },
    openDetailDialog({ type, form = {} }) {
      const types = {
        add:
          this.$l('INDEX.dialog_title_order_goods_spec_add_info') ||
          '添加订单产品规格信息',
        edit:
          this.$l('INDEX.dialog_title_order_goods_spec_edit_info') ||
          '编辑订单产品规格信息',
        detail:
          this.$l('INDEX.dialog_title_order_goods_spec_detail_info') ||
          '订单产品信息规格详情',
      }
      if (!form.uuid) {
        form.uuid = this.getUUID()
      }
      this.goodsSpecDetailDialogParams = {
        visible: true,
        title: types[type],
        form,
        type: type,
        disabled: type === 'detail',
      }
    },
    batchDel() {
      const listCode = this.$refs.tableMain.getCheckboxRecords()
      if (listCode) this.submitDel(listCode)
    },
    submitDel(listCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.$api.orderGoodsSpecDelApi({ listCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success',
          })
          this.getData()
        })
      })
    },
    save() {
      this.$refs.detailForm.getForm().then((res) => {
        if (!res) return
        for (let index = 0; index < this.tableData.length; index++) {
          if (res.uuid === this.tableData[index].uuid) {
            this.$set(this.tableData, index, res)
            this.close()
            return
          }
        }
        this.tableData.push(res)
        this.close()
      })
    },
    close() {
      this.goodsSpecDetailDialogParams.visible = false
    },
    getTableData() {
      return this.tableData
    },
    getUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        var r = (Math.random() * 16) | 0,
          v = c == 'x' ? r : (r & 0x3) | 0x8
        return v.toString(16)
      })
    },
  },
}
</script>
